import web from "../web";

class TypesevaluationsService {
    index(token){
        return web.get("/api/typesevaluations", { headers: { 'Authorization': 'Bearer '+token } })
    }
    store(data, token){
        return web.post("/api/typesevaluations", data, { headers: { 'Authorization': 'Bearer '+token } })
    }

    show(id,token){
        return web.get(`/api/typesevaluations/${id}/show`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    update(data,token){
        return web.put("/api/typesevaluations/update", data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    delete(id,token){
        return web.delete(`/api/typesevaluations/${id}/delete`,{ headers: { 'Authorization': 'Bearer '+token } })
    }
}

export default new TypesevaluationsService()